import React from 'react';

import Thecommonty from './Thecommonty';
import Generallyinclude from './Generallyinclude';
import Commontabl from './Commontabl';


const Thecommontyp = () => {
    return (
        <div>
             <Thecommonty />
            <Generallyinclude />
            <Commontabl />
        </div>
    );
};

export default Thecommontyp;
